import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {FeatureTypeService, NotificationsService} from '@catcore/services';
import {FeatureType, FeatureTypeCreateInfo} from '@catcore/services/feature-type/feature-type';
import {WizardOptions, WizardPane} from '@catuiform/types';
import {SelectItem} from 'primeng/primeng';

interface Wizard {
  introduction: WizardPane;
  properties: WizardPane;
  finishAndNextStep: WizardPane;
  options: WizardOptions;
}

@Component({
  templateUrl: './feature-welcome.component.html',
  styleUrls: ['./feature-welcome.component.scss'],
})
export class FeatureWelcomeComponent implements OnInit {
  wizard: Wizard;
  featureForm: FormGroup;
  statuses: SelectItem[] = [];
  featureTypeGroups: SelectItem[] = [];

  createdFeatureType: FeatureType = null;

  isCompleted = false;

  constructor(private route: ActivatedRoute,
              private featureTypeService: FeatureTypeService,
              private notificationService: NotificationsService) {
    this.wizard = {
      introduction: {valid: true, touched: true, label: 'Start'},
      properties: {valid: false, touched: false, label: 'Properties'},
      finishAndNextStep: {valid: false, touched: false, label: 'Finish and follow up steps'},
      options: {panePosition: 'center'},
    };

    this.featureForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      status: new FormControl('', [Validators.required]),
      isPublic: new FormControl(true, []),
    });

  }

  ngOnInit() {
    this.route.data.subscribe((resolved) => {
      this.updateStatuses(resolved.statuses);
      this.updateFeatureGroupTypes(resolved.featureTypeGroups);
    });
    this.featureTypeService.resetCurrent();
  }

  afterIntroduction() {
    this.wizard.introduction.touched = true;
  }

  validateNewFeatureForm() {
  }

  saveNewFeature() {
    this.wizard.finishAndNextStep.touched = true;
    this.wizard.finishAndNextStep.valid = true;

    this.featureTypeService
      .create(
        {
          name: this.featureForm.value.name,
          description: this.featureForm.value.description,
          status: this.featureForm.value.status,
          isPublic: this.featureForm.value.isPublic,
        } as FeatureTypeCreateInfo)
      .subscribe((featureType: FeatureType) => {
        this.createdFeatureType = featureType;
        this.isCompleted = true;
        this.notificationService.success(
          'Feature type created',
          `The Feature type "${featureType.name}" was successfully created`,
        );
      });
  }

  resetFormResult() {
    this.createdFeatureType = null;
  }

  private optionListOf(itemList) {
    const options = [];
    itemList.forEach((item) => options.push({label: item.name, value: item}));
    return options;
  }

  private updateStatuses(itemsList) {
    this.statuses = this.optionListOf(itemsList);
  }

  private updateFeatureGroupTypes(itemsList) {
    this.featureTypeGroups = this.optionListOf(itemsList);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/features/components/feature-welcome/feature-welcome.component.ts